export default "__VITE_ASSET__ye5ao_i3__"